import { AxiosRequestConfig, AxiosResponse } from "axios";
import { API_PATH } from "../server-data";
import { axiosAuth } from "./interceptor";

export const getUserAnnouncement = (): // AnnouncementObject: any
Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      user: JSON.parse(localStorage.getItem("user") || "{}")?.id,
    },
  };
  return axiosAuth.get(API_PATH().apis.userannoucements, config);
};

export const announcementUserTransaction = (
  AnnouncementObject: any
): Promise<AxiosResponse> => {
  const businessUnit =
    localStorage.getItem("currentBusinessUnit") &&
    JSON.parse(localStorage.getItem("currentBusinessUnit") || "{}").id;
  const user = JSON.parse(localStorage.getItem("user") || "{}")?.id;
  AnnouncementObject.owner = user;
  AnnouncementObject.businessUnit = businessUnit;

  AnnouncementObject.discarded = true;

  return axiosAuth.post(
    API_PATH().apis.announcementtransaction,
    AnnouncementObject
  );
};
